import React from "react";
import { CheckCircle2 } from "lucide-react";
import { ReceivingDiscrepancy } from "src/types";
import { ResolveIssue, NoDataDisplay } from "src/components";

interface ResolveReceivingDiscrepancyCardProps {
  id: string | undefined;
  resolveIssue: (id: string, resolutionDetails: string) => Promise<ReceivingDiscrepancy | undefined>;
}

export const ResolveReceivingDiscrepancyCard: React.FC<ResolveReceivingDiscrepancyCardProps> = ({
  id,
  resolveIssue
}) => {
  if (!id) return <NoDataDisplay />;

  return (
    <div className="border border-neutral-200 rounded-2xl p-5 bg-white">
      <h3 className="text-sm font-semibold text-black mb-4 tracking-wide uppercase flex items-center">
        <CheckCircle2 className="w-4 h-4 mr-2" />
        Resolve Issue
      </h3>
      <ResolveIssue<ReceivingDiscrepancy> resolveIssue={resolveIssue} id={id} />
    </div>
  );
};
